<template>
  <b-container fluid>
    <b-row class="py-2">
      <b-col cols="auto">
        <span>ค้นหารายการสินค้า</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          v-model="searchItemValue"
          placeholder="ค้นหาสินค้า"
          @input="itemSearchHandler"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :fields="fields"
          :items="itemsUse"
          :is-busy="isBusy"
          sticky-header
          responsive
          selectable
          show-empty
          empty-text="ไม่มีผลลัพธ์"
          class="item-invoice-table"
        >
          <template slot="action" slot-scope="data">
            <b-button variant="warning" @click="chooseItemHandler(data.item)">เลือก</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row
      align-h="end"
      style="background: #808080; padding: 1rem; margin: 1px; color: #FFF; font-weight: bold;"
    >
      <b-col>
        <b-row align-h="end">
          <b-col cols="auto">รวม</b-col>
          <b-col cols="auto">{{ $numeral(orderPrice.toFixed(2)).format('0,0[.]00') }} บาท</b-col>
        </b-row>
        <template v-if="discountInput > 0">
          <b-row align-h="end">
            <b-col class="my-auto" cols="auto">ส่วนลด</b-col>
            <b-col
              class="my-auto"
              cols="auto"
            >{{ $numeral(discountInput.toFixed(2)).format('0,0[.]00') }} {{ discountType | discountTypeLabel }}</b-col>
          </b-row>
        </template>
        <template v-if="toInputCheck">
          <b-row align-h="end">
            <b-col cols="auto">ค่าขนส่ง</b-col>
            <b-col cols="auto">{{ $numeral((+toInput).toFixed(2)).format('0,0[.]00') }} บาท</b-col>
          </b-row>
        </template>
        <template v-if="withHoldingTax">
          <b-row align-h="end">
            <b-col cols="auto">ภาษี ณ ที่จ่าย 3%</b-col>
            <b-col cols="auto">{{ $numeral(allPrice | holdingTax).format('0,0[.]00') }} บาท</b-col>
          </b-row>
        </template>
        <b-row align-h="end">
          <b-col cols="auto">รวมทั้งสิ้น</b-col>
          <b-col cols="auto">{{ $numeral(netPrice).format('0,0[.]00') }} บาท</b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "ItemInvoiceTable",
  filters: {
    holdingTax(value) {
      return (value * 0.03).toFixed(2);
    },
    discountTypeLabel(value) {
      return value === "percent" ? "%" : "บาท";
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    labInvoicesChecks: {
      type: Array,
      default: () => [],
    },
    selectLabInvoice: {
      type: Function,
    },
    itemsSelected: {
      type: Array,
      default: () => [],
    },
    toInputCheck: {
      type: Boolean,
      default: false,
    },
    withHoldingTax: {
      type: Boolean,
      default: false,
    },
    toInput: {
      type: Number | String,
      default: 0,
    },
    orderPrice: {
      type: Number,
      default: 0,
    },
    discountType: {
      type: String,
      default: "percent",
    },
    discountInput: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      fields: [
        { key: "item_code", label: "รหัสสินค้า" },
        { key: "name", label: "ชื่อสินค้า" },
        { key: "action", label: "ACTIONS" },
      ],
      itemsUse: [],
      searchItemValue: "",
    };
  },
  computed: {
    allPrice() {
      let allPrice = this.orderPrice;

      const discount = this.getDiscount(allPrice, this.discountInput);

      allPrice -= discount;

      allPrice = allPrice < 0 ? 0 : allPrice;

      if (this.toInputCheck) {
        allPrice += +this.toInput;
      }

      return allPrice;
    },
    netPrice() {
      let netPrice = this.allPrice;

      const holdingTax = +(this.allPrice * 0.03).toFixed(2);
      if (this.withHoldingTax) {
        netPrice -= holdingTax;
      }
      return netPrice.toFixed(2);
    },
    itemsInput: {
      get() {
        return this.items;
      },
      set(value) {
        this.$emit("update:items", value);
      },
    },
    labInvoicesChecksInput: {
      get() {
        return this.labInvoicesChecks;
      },
      set(value) {
        this.$emit("update:labInvoicesChecks", value);
      },
    },
    itemsSelectedInput: {
      get() {
        return this.itemsSelected;
      },
      set(value) {
        this.$emit("update:itemsSelected", value);
      },
    },
    labsDataCheck() {
      return this.items.filter((labInvoice, index) =>
        this.labInvoicesChecks.includes(index)
      );
    },
  },
  watch: {
    items(val) {
      const itemsSelectedIds = this.itemsSelectedInput.map(
        (itemSelected) => itemSelected.id
      );
      this.itemsUse = val
        .filter((item) => !itemsSelectedIds.includes(item.id))
        .filter(
          (item) =>
            item.name
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase()) ||
            item.item_code
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase())
        );
    },
    itemsSelectedInput(value) {
      const itemsSelectedIds = this.itemsSelectedInput.map(
        (itemSelected) => itemSelected.id
      );
      this.itemsUse = this.items
        .filter((item) => !itemsSelectedIds.includes(item.id))
        .filter(
          (item) =>
            item.name
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase()) ||
            item.item_code
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase())
        );
    },
  },
  mounted() {
    const itemsSelectedIds = this.itemsSelectedInput.map(
      (itemSelected) => itemSelected.id
    );
    this.itemsUse = this.items
      .filter((item) => !itemsSelectedIds.includes(item.id))
      .filter(
        (item) =>
          item.name
            .toLowerCase()
            .includes(this.searchItemValue.toLowerCase()) ||
          item.item_code
            .toLowerCase()
            .includes(this.searchItemValue.toLowerCase())
      );
  },
  methods: {
    getDiscount(price, value) {
      if (this.discountType === "percent") {
        return price * (value / 100);
      } else if (this.discountType === "baht") {
        return value;
      }
    },
    chooseItemHandler(value) {
      this.itemsSelectedInput.push({ ...value, quantity: 1 });
      const itemsSelectedIds = this.itemsSelectedInput.map(
        (itemSelected) => itemSelected.id
      );
      this.itemsUse = this.items
        .filter(
          (item) =>
            item.name
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase()) ||
            item.item_code
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase())
        )
        .filter((item) => !itemsSelectedIds.includes(item.id));
    },
    itemSearchHandler() {
      const itemsSelectedIds = this.itemsSelectedInput.map(
        (itemSelected) => itemSelected.id
      );
      this.itemsUse = this.items
        .filter(
          (item) =>
            item.name
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase()) ||
            item.item_code
              .toLowerCase()
              .includes(this.searchItemValue.toLowerCase())
        )
        .filter((item) => !itemsSelectedIds.includes(item.id));
    },
    updateCheckLabInvoice(index) {
      if (this.labInvoicesChecksInput.includes(index)) {
        this.labInvoicesChecksInput = this.labInvoicesChecksInput.filter(
          (check) => check !== index
        );
      } else {
        this.labInvoicesChecksInput.push(index);
      }
    },
    notSelectAllHandler() {
      this.labInvoicesChecksInput = [];
    },
    selectAllHandler() {
      // const indexAll = Object.keys(this.itemsInput).map(index => +index)
      const indexAll = this.itemsInput.map((index) => index.ln);
      this.labInvoicesChecksInput = indexAll;
    },
    getPromotionDiscount(promotion) {
      const type = promotion.type;
      const discountType = promotion.discount_type;
      let value = promotion.value;
      let discount = 0;

      if (type === "all") {
        if (discountType === "percent") {
          discount += this.orderPrice.toFixed(2) * (value / 100);
        } else if (discountType === "baht") {
          discount += value;
        }
      } else if (type === "each") {
        if (promotion.set_test_id) {
          this.itemsInput.forEach((item) => {
            let productDiscount = item.labInvoices.find(
              (labInvoice) => labInvoice.set_test_id === promotion.set_test_id
            );
            if (productDiscount) {
              if (discountType === "percent") {
                discount += +(
                  productDiscount.price.toFixed(2) * (+value / 100).toFixed(2)
                ).toFixed(2);
              } else if (discountType === "baht") {
                discount += +(productDiscount.price - +value);
              }
            }
          });
        } else if (promotion.test_id) {
          this.labsDataCheck.forEach((item) => {
            let productDiscount = item.labInvoices.find(
              (labInvoice) => labInvoice.test_id === promotion.test_id
            );
            if (productDiscount) {
              if (discountType === "percent") {
                discount += +(
                  productDiscount.price.toFixed(2) * (+value / 100).toFixed(2)
                ).toFixed(2);
              } else if (discountType === "baht") {
                discount += +(productDiscount.price - +value);
              }
            }
          });
        }
      }

      return discount.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-invoice-table {
  height: 35rem;
  /*width: 45rem;*/
  width: 100%;
  border: 1px solid #6b757f;
}
</style>
